import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import css from './globalRegistrationPopup.module.css';

const GlobalRegistrationPopup = ({ authUser }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    
    const [isVisible, setIsVisible] = useState(false);
    const [isHiding, setIsHiding] = useState(false);
    const isAuthenticated = authUser?.isAuthenticated;

    useEffect(() => {
        if (isAuthenticated) {
            setIsVisible(false);
            return;
        }
        const path = location.pathname;
        let timer;
        if (path.startsWith('/lesson/')) {
            timer = setTimeout(() => setIsVisible(true), 2000);
        } else if (path === '/survey') {
            timer = setTimeout(() => setIsVisible(true), 500);
        } else {
            setIsVisible(false);
        }
        return () => clearTimeout(timer);
    }, [isAuthenticated, location.pathname]);

    const handleClose = () => {
        setIsHiding(true);
        setTimeout(() => {
            setIsVisible(false);
            setIsHiding(false);
        }, 300);
    };

    const handleRegister = () => {
        navigate('/signup');
        handleClose();
    };

    if (!isVisible && !isHiding) return null;

    return (
        <div className={`${css.overlay} ${isHiding ? css.fadeOut : ''}`}>
            <div className={`${css.popup} ${isHiding ? css.scaleOut : ''}`}>
                <button className={css.closeBtn} onClick={handleClose}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                    </svg>
                </button>
                
                <div className={css.iconWrap}>
                    <div className={css.pulseBg}></div>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
                        <circle cx="12" cy="7" r="4"/>
                    </svg>
                </div>
                
                <h3 className={css.title}>{t('Save your progress!')}</h3>
                <p className={css.desc}>
                    {t('You are currently learning as a guest. Create a free account to save learned words, completed lessons, and your personal plan.')}
                </p>
                
                <div className={css.benefits}>
                    <div className={css.benefitItem}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                        {t('Personal account')}
                    </div>
                    <div className={css.benefitItem}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                        {t('Personal plan')}
                    </div>
                    <div className={css.benefitItem}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                        {t('Progress saving')}
                    </div>
                </div>
                
                <div className={css.actions}>
                    <button className={css.btnPrimary} onClick={handleRegister}>
                        {t('Register for free')}
                    </button>
                    <button className={css.btnSecondary} onClick={handleClose}>
                        {t('Continue as guest')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GlobalRegistrationPopup;